
import { JobService } from "@/services/job-service";
import Vue from "vue";
import { Job } from "../../models/job";

export default Vue.extend({
	data() {
		return {
			JobService,
		};
	},
	computed: {
		jobs():Job[]{
			return JobService.getJobs();
		},
		runningCount():number {
			return this.jobs.filter(j => j.isRunning).length;
		},
		// Taken in de wachtrij op de server, van alle gebruikers samen; een lopende taak zit daar niet meer in
		queuedCount():number {
			return JobService.getQueuedJobs();
		},
		summary():string {
			let parts = [] as string[];
			if (this.runningCount > 0) {
				parts.push(this.$ctc("jobs-running", this.runningCount, {count: this.runningCount}).toString());
			}
			if (this.queuedCount > 0) {
				parts.push(this.$ctc("jobs-queued", this.queuedCount, {count: this.queuedCount}).toString());
			}
			return parts.join(" · ");
		}
	},
	methods: {
		async removeJobFromQueue(job:Job):Promise<void> {
			await JobService.removeJobFromQueue(job);
		},
		async cancelJob(job:Job):Promise<void>{
			let message = this.$ct("are-you-sure-you-want-to-cancel-job");
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			await JobService.cancelJob(job);
		},
		async uncancelJob(job:Job):Promise<void>{
			await JobService.unCancelCurrent(job);
		},
	},
	i18nEx: {
		componentPrefix: "components.common-NotificationJobList"
	}
});
